<template>

  <modalo
    :title="questionform.name"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => questionform">

    <form id="questionform-form" v-on:submit.prevent="saveQuestionform(questionform)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="questionform.name">
        <ValidateMessage :error="validateErrors['name']" />
      </div>
      
      <div class="form-group">
        <div class="form-row align-items-center">
          <div class="col-sm-3 my-1">
            <label>{{ $t('Type') }}</label>
            <select
              class="form-control"
              v-model="questionform.type">
              <option value="quiz">{{ $t('Questionnaire') }}</option>
              <option value="test">{{ $t('Test') }}</option>
            </select>
          </div>
          <div class="col-sm-3 my-1" v-if="isTest">
            <label>Tempo limite</label>
            <div
              class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="--"
                v-model="questionform.time_limit"
                maxlength="4">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon2">minutos</span>
              </div>
            </div>
            <ValidateMessage :error="validateErrors['time_limit']" />
          </div>
        </div>
      </div>
      
      <div class="form-group mb-3">
        <label>{{ $t('Message') }}</label>
        <input
          type="text"
          class="form-control mb-1"
          v-model="questionform.subject"
          :placeholder="$t('Subject')">
        <ValidateMessage :error="validateErrors['subject']" />
        <textarea-editable
          v-model="questionform.body"
          :variables="['[candidate_full_name]', '[candidate_first_name]', '[job_title]', '[company_name]', '[member_full_name]', '[member_first_name]']"
          editor-model="html"
          :enable-link="true"
          :enable-img="true">
          </textarea-editable>
        <ValidateMessage :error="validateErrors['body']" />
      </div>

      <div class="mb-3">
        <h5>{{ $t('Questions') }}</h5>
      </div>

      <div class="list-form" v-sortable="{ handle: '.sortable-move', items: questionform.questions}">
        
        <div 
          class="card" 
          v-for="(question, question_index) in questionform.questions"
          :key="question_index">
            
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="mr-auto">
                <a
                  href="javascript:void(0)"
                  class="sortable-move text-secondary">
                  <i class="fas fa-arrows-alt" />
                  </a>
              </div>
              <div
                class="pr-3"
                v-if="!isTest">
                <input
                  type="checkbox"
                  v-model="question.required">
                  {{ $t('Required') }}
              </div>
              <div>
                <a
                  href="javascript:void(0)"
                  class="text-secondary"
                  @click="removeQuestion(question_index)">
                  <i class="far fa-trash-alt" />
                  </a>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="form-group">
              <textarea-autosize
                type="text" 
                class="form-control" 
                :placeholder="$t('Question')" 
                v-model="question.label"
                :min-height="30"
                :max-height="350">
                </textarea-autosize>
              <ValidateMessage :error="validateErrors['questions.' +question_index+ '.label']" />
            </div>

            <div class="form-group">
              <div
                class="mb-3"
                v-if="question.image_media_id">
                <img v-bind:src="imageResizeUrl + encodeURIComponent(question.image_media_id.url)">
              </div>
              <InputOnePhoto
                v-model="question.image_media_id"
                :removeOption="true" />
              <ValidateMessage :error="validateErrors['questions.' +question_index+ '.image_media_id']" />
            </div>

            <div class="row mb-3">
              <div class="col-sm-9">
                <select type="text" class="form-control" v-model="question.type">
                  <option value="text">{{ $t('Short text') }}</option>
                  <option value="textarea">{{ $t('Long text') }}</option>
                  <option value="radio">{{ $t('List of options (Single choice)') }}</option>
                  <option value="checkbox">{{ $t('List of options (Multiple choice)') }}</option>
                  <option value="file">Arquivo</option>
                  <!--<option value="mostleast">mostleast</option>-->
                </select>
                <ValidateMessage :error="validateErrors['questions.' + question_index + '.type']" />
              </div>
              <div class="col-sm-3" v-if="isTest">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">Pontos</span>
                  </div>
                  <input type="text" class="form-control" placeholder="" v-model="question.score_weight" maxlength="2">
                </div>
                <ValidateMessage :error="validateErrors['questions.' + question_index + '.score_weight']" />
              </div>
            </div>

            <div v-if="['radio', 'checkbox', 'mostleast'].includes(question.type)">
              <ul
                class="form-items"
                v-sortable="{ handle: '.move', items: question.options}">
                <li
                  v-for="(option, option_index) in question.options">
                  <div><a href="javascript:void(0)" class="move text-secondary"><i class="fas fa-arrows-alt" /></a></div>
                  <div class="form-items-input">
                    <input 
                      type="text" 
                      :placeholder="$t('Alternative')" 
                      v-model="option.title">
                    <ValidateMessage :error="validateErrors['questions.' + question_index + '.options.' + option_index + '.title']" />
                  </div>
                  <div v-if="isTest">
                    <div class="text-truncate"><input type="checkbox" v-model="option.correct" style="margin: 0"> {{ $t('Correct') }}</div>
                    <ValidateMessage :error="validateErrors['questions.' + question_index + '.options.' + option_index + '.correct']" />
                  </div>
                  <div><a href="javascript:void(0)" @click="removeOption(question, option_index)" class="text-secondary"><i class="fas fa-times" /></a></div>
                </li>
              </ul>
              <ValidateMessage :error="validateErrors['questions.' + question_index + '.options']" />
              <br>
              <a href="javascript:void(0)"  @click="addOption(question.options)">Adicionar opção</a>
            </div>
          </div>

        </div>

      </div>

      <div><a href="javascript:void(0)" @click="addQuestion()">{{ $t('Add question') }}</a></div>

      <ValidateMessage :error="validateErrors['questions']" />

    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="questionform-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
            type="button"
            class="btn btn-danger"
            @click="deleteQuestionform(questionform._id)">{{ $t('Delete') }}</button>-->  
      </div>
    </template>

  </modalo>

</template>

<script>
import InputOnePhoto from '@/components/Fields/InputOnePhoto'
import config from '@/config'

export default {
  name: 'QuestionformForm',
  components: {
    InputOnePhoto
  },
  props: [
    'initQuestionform'
  ],
  data () {
    return {
      group_edit: false,
      loading: false,
      questionform: this.defaultValues(this.initQuestionform),
      validateErrors: false
    }
  },
  computed: {
    isTest () {
      return this.questionform.type === 'test'
    },
    imageResizeUrl () {
      return `${config.modfile_url}image/100x100x0/`
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        'type': 'quiz',
        'questions': [{
          'label': '',
          'required': true,
          'type': 'text', // [radio, textarea, checkbox, text]
          'options': []
        }]
      }, values)
    },
    addQuestion () {
      var newItem = {
        'label': '',
        'required': true,
        'score': 10,
        'type': 'text', // [radio, textarea, checkbox, text]
        'options': []
      }

      this.questionform.questions.push(newItem)
    },
    removeQuestion (index) {
      this.questionform.questions.splice(index, 1)
    },
    addOption (question) {
      question.push({
        'item': '',
        'correct': false
      })
    },
    removeOption (question, index) {
      question.options.splice(index, 1)
    },
    /* hideModal  */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveQuestionform
    */
    saveQuestionform (data) {
      if (data._id) this.updateQuestionform(data)
      else this.createQuestionform(data)
    },
    /*
    createQuestionform
    */
    createQuestionform (data) {
      this.loading = true

      this.$store
      .dispatch('createQuestionform', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateQuestionform
    */
    updateQuestionform (data) {
      this.loading = true

      this.$store
      .dispatch('updateQuestionform', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteQuestionform (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteQuestionform', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Questionform/QuestionformForm.vue